import React from 'react'
import Table from 'react-bootstrap/Table';
import Tooltip from 'react-bootstrap/Tooltip';
import * as AiIcons from "react-icons/ai";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { Button, Container, FormControl, FormLabel, Row, Col } from 'react-bootstrap';
import UpdateUser from './UpdateUser';
import { PiWarningDuotone } from "react-icons/pi";
import { AiFillCheckCircle } from "react-icons/ai";
import ViewUserProfile from './ViewUserProfile';
import { Link } from 'react-router-dom';

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>Teléfono</th>
        <th style={{width:'30%'}}>Nombre</th>
        <th className='d-none d-sm-table-cell' style={{width:'30%'}}>Correo</th>
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Habilitado</th>
        <th style={{width:'5%'}}>Ver Perfil</th>
        <th style={{width:'5%'}}>{props.mode==0?'Editar':''}</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  if (props.usersObj) {
    const rows = props.usersObj.map((row, index) => { 
      return (      
        <tr key={index}>        
          <td>
            <a href={"sms:+" + row.telefonomovil}>
              {row.telefonomovil}
            </a>                        
          </td>
          <td>              
            {(row.primerapellido + ' ' + (row.segundoapellido?row.segundoapellido:"")).trim() + ", " + (row.primernombre + ' ' + (row.segundonombre?row.segundonombre:"")).trim()}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row.email}
          </td>            
          <td className='d-none d-sm-table-cell' align='center'>  
            <div style={{color:'red'}}>
              {(row.habilitado === 0) && <PiWarningDuotone size={25}/>}
              
            </div>

            <div style={{color:'green'}}>
              {(row.habilitado === 1) && <AiFillCheckCircle size={25}/>}
            </div>
          </td>  
          <td>   
            <Button variant='link' style={{padding:0, margin:0}} >
              <Link to={"/viewuserprofile/" + row.id} style={{textDecoration:'none'}}>Ver</Link>
            </Button>
          </td>                  

          <td align='center'>  
            {(props.mode==0) &&
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderEditTooltip}>        
                <UpdateUser 
                  edituser = {row}
                  userid = {row.id}
                  username = {row.username}
                  email = {row.email}/>    
              </OverlayTrigger>              
            }
            {(props.mode==1) &&
              <Button onClick={() => {
                //console.log(row);
                props.onSelected(row.id,row.username,row.email);
                props.handleClose();
              }} variant='link' value={row.id}>Select</Button>
            } 
          </td>                    
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the user.
  </Tooltip>
);



const UsersList = (props) => {        
  
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode} />
            <TableBody handleClose={props.handleClose} onSelected={props.onSelected} mode={props.mode} usersObj={props.listOfUsers} />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default UsersList;